export const IS_LOADING_ANALTYICS = "IS_LOADING_ANALTYICS";
export const ANALTYICS_DATA_SUCCESS = "ANALTYICS_DATA_SUCCESS";
export const ANALTYICS_DATA_FAILED = "ANALTYICS_DATA_FAILED";
